module.exports = __webpack_public_path__ + "static/media/video-08.97a61c40.mp4";